var map = {
	"./bet.mp3": "4a01",
	"./full.mp3": "2d22",
	"./s_wheel.mp3": "353e",
	"./sr.mp3": "adfb",
	"./sw.mp3": "c6cb",
	"./win.mp3": "ef7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1379";